{
  "CHAT_LIST": {
    "LOADING": "Görüşmeler getiriliyor",
    "LOAD_MORE_CONVERSATIONS": "Daha fazla konuşma yükleyin",
    "EOF": "Tüm görüşmeler yüklendi 🎉",
    "LIST": {
      "404": "Bu grupta aktif görüşme yok."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Konuşmalar",
    "MENTION_HEADING": "Bahsedilmeler",
    "UNATTENDED_HEADING": "İlgilenilmemiş",
    "SEARCH": {
      "INPUT": "Kişileri, Sohbetleri, Kaydedilen Yanıtları Ara .."
    },
    "SEARCH_MESSAGES": "Sohbetlerde ara",
    "SEARCH_INPUT_PLACEHOLDER": "Sohbetlerde ara...",
    "FILTER_ALL": "Hepsi",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Benim",
      "unassigned": "Atanmamış",
      "all": "Hepsi"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Yanıta yapıştır",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Aç",
        "BUY": "Satın al"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Açık"
      },
      "resolved": {
        "TEXT": "Çözüldü"
      },
      "pending": {
        "TEXT": "Bekliyor"
      },
      "snoozed": {
        "TEXT": "Susturuldu"
      },
      "all": {
        "TEXT": "Hepsi"
      }
    },
    "VIEW_FILTER": "Görünüm",
    "SORT_TOOLTIP_LABEL": "Görüşmeleri sırala",
    "CHAT_SORT": {
      "STATUS": "Durum",
      "ORDER_BY": "Sırala"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Oluşturuldu",
      "LAST_ACTIVITY": "Son etkinlik:",
      "LAST_CUSTOMER_MESSAGE": "Son müşteri mesajı:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Son aktivite: En eski"
      },
      "last_activity_at_desc": {
        "TEXT": "Son Aktivite: En Yeni"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Son müşteri mesajı: En eski"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Son müşteri mesajı: En yeni"
      },
      "created_at_desc": {
        "TEXT": "Oluşturulma: En Yeni"
      },
      "created_at_asc": {
        "TEXT": "Oluşturulma: En Eski"
      },
      "priority_desc": {
        "TEXT": "Öncelik: Yüksek"
      },
      "priority_asc": {
        "TEXT": "Öncelik: Düşük"
      },
      "priority_created_at_desc": {
        "TEXT": "Öncelik + Oluşturulma: En yeni"
      },
      "priority_created_at_asc": {
        "TEXT": "Öncelik + Oluşturulma: En eski"
      },
      "waiting_since_asc": {
        "TEXT": "Cevap Bekleyen: Uzun olan"
      },
      "waiting_since_desc": {
        "TEXT": "Cevap Bekleyen: Kısa olan"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Görsel mesaj"
      },
      "audio": {
        "CONTENT": "Sesli mesaj"
      },
      "video": {
        "CONTENT": "Video mesajı"
      },
      "file": {
        "CONTENT": "Dosya eklentisi"
      },
      "location": {
        "CONTENT": "Yer"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "bir url paylaştı"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Görüşmeleri sırala",
      "DROPDOWN_TITLE": "Sırala",
      "ITEMS": {
        "LATEST": {
          "NAME": "Son etkinlik",
          "LABEL": "Son etkinlik"
        },
        "CREATED_AT": {
          "NAME": "Oluşturma zamanı",
          "LABEL": "Oluşturma zamanı"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Son kullanıcı mesajı",
          "LABEL": "Son mesaj"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "E-posta ile alındı",
    "VIEW_TWEET_IN_TWITTER": "Twitter'da tweet'i görüntüleyin",
    "REPLY_TO_TWEET": "Bu tweet'i yanıtla",
    "LINK_TO_STORY": "Instagram hikayesine git",
    "SENT": "Başarıyla gönderildi",
    "READ": "Başarıyla okundu",
    "DELIVERED": "Başarıyla teslim edildi",
    "NO_MESSAGES": "Mesaj yok",
    "NO_CONTENT": "Kullanılabilir içerik yok",
    "HIDE_QUOTED_TEXT": "Alıntı Yapılan Mesajı Gizle",
    "SHOW_QUOTED_TEXT": "Alıntı Yapılan Mesajı Göster",
    "HIDE_AUTOMATED_MESSAGE": "Otomatik Yanıt İçeriğini Gizle",
    "SHOW_AUTOMATED_MESSAGE": "Otomatik Yanıt İçeriğini Göster",
    "AUTOMATED_MESSAGE": "Otomatik Yanıt",
    "MESSAGE_READ": "Oku",
    "SENDING": "Sending"
  }
}
